// extracted by mini-css-extract-plugin
export default {"priceInput":"vSyLjEalaibfb9dh65QA"};